<template>
  <product :item="item">
    <template v-slot:s1>
      {{val1 | price(currency === 'USD' ? 'USD' : item.coin, currency === 'USD' ? 4 : 8)}}
      <span class="subtitle-1" v-if="slot1[1]">/{{blockchain[item.coin].unit}}/Day</span>
    </template>
    <template v-slot:s2>
      <span class="dealMeta">ROI</span>
      <colored :value="val2" :format="slot2[2] || 'percent'" />
    </template>
  </product>
</template>

<script>
import { mapState } from "vuex";
import { unit, price } from "../../filters";

import Colored from "../Colored";
import Product from "./Product";

export default {
  name: "CloudMining",
  props: ["item"],
  filters: { unit, price },
  components: {Colored, Product },
  computed: {
    ...mapState(["blockchain"]),
    ...mapState("product", ["slot1", "slot2", "currency"]),
    val1() {
      const [,,field] = this.slot1;
      let v = this.item[field] || field(this.item);
      if (this.currency !== 'USD') v /= this.blockchain[this.item.coin].price;
      return v;
    },
    val2() {
      const [,field] = this.slot2;
      return this.item[field] || field(this.item);
      // if (this.currency !== 'USD') v /= this.item.btc_price;
      // return v;
    }
  }
}
</script>

<style scoped>

</style>